<template>
  <div class="w-full">
    <a-spin :spinning="spinning">
      <div class="m-auto text-base" :style="{ width: '750px' }">
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          项目信息
        </div>
        <div class="w-full py-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            项目名称:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-input-group compact>
              <a-textarea
                disabled
                autoSize
                :value="project.name"
                style="width: calc(100% - 188px)"
              ></a-textarea>
              <a-button type="primary" @click="projectFlag = true">选择项目</a-button>
            </a-input-group>
          </div>
        </div>
        <template v-if="project.id > 0">
          <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              备案登记号:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }">
              {{ project.record_no }}
            </div>
          </div>
          <div
            class="w-full pb-4 overflow-hidden"
            :style="{ width: '750px' }"
            v-if="project.temp_category_id == 2"
          >
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              开标时间:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }">
              {{ project.bidder_timef }}
            </div>
          </div>
          <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              招标人:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }">
              {{ project.proprietor }}
            </div>
          </div>
          <div
            class="w-full pb-4 overflow-hidden"
            :style="{ width: '750px' }"
            v-if="project.temp_category_id != 2"
          >
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }"
              ><span class="text-red-500">*</span> 中标通知书:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }">
              <div
                ><a
                  v-if="pd.bidding_file"
                  :href="previewlink($ossUrl + pd.bidding_file)"
                  target="__blank"
                  >{{ pd.bidding_file_name }}</a
                ></div
              >
              <a-upload
                :before-upload="beforeUpload"
                :customRequest="api2"
                accept="application/pdf,image/jpeg,image/png,.docx,.doc,.xlsx,.xls"
                :show-upload-list="false"
              >
                <a-button :icon="loading ? 'loading' : 'plus'">上传</a-button>
              </a-upload>
            </div>
          </div>
          <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }" v-if="project.money">
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              担保额度:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }">
              {{ project.money ? project.money.toFixed(2) : '' }}
              <span class="text-red-500">
                {{ convertCurrency(parseFloat(project.money ? project.money.toFixed(2) : '')) }}
              </span>
            </div>
          </div>
          <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }" v-else>
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              <span class="text-red-500">*</span>担保额度:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }">
              <a-input-number
                v-model="pd.money"
                placeholder="(必填)"
                style="width: 200px"
                :min="0"
              />
              <span class="text-red-500">
                {{ pd.money > 0 ? `(${convertCurrency(pd.money)})` : '' }}
              </span>
            </div>
          </div>
          <div
            class="w-full pb-4 overflow-hidden"
            :style="{ width: '750px' }"
            v-if="project.temp_category_id == 2"
          >
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              担保费:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }"
              >{{ project.poundage ? project.poundage.toFixed(2) : '' }}
              <span class="text-red-500">
                {{ convertCurrency(project.poundage) }}
              </span>
            </div>
          </div>
          <div
            class="w-full pb-4 overflow-hidden"
            :style="{ width: '750px' }"
            v-if="project.temp_category_id != 2"
          >
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              <span class="text-red-500">*</span>担保期限:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }"
              ><a-input-number
                v-model="pd.effect_month"
                placeholder="(必填)"
                style="width: 180px"
                :min="1"
              />
              月
            </div>
          </div>
          <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
            <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
              推荐码:
            </div>
            <div class="float-right pl-2" :style="{ width: '550px' }">
              <a-input v-model="pd.r_code" placeholder="(选填)" style="width: 200px" />
            </div>
          </div>
        </template>
        <div
          class="w-full px-4 my-4 text-xl text-left border-4 border-t-0 border-b-0 border-r-0 border-blue-400 border-solid text-bold"
          :style="{ width: '750px' }"
        >
          企业信息
        </div>
        <div
          v-if="permission(['contract', 'apply/:id?'], 'bind_user')"
          class="w-full pb-4 overflow-hidden"
          :style="{ width: '750px' }"
        >
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            经办人:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-input-group compact>
              <a-textarea disabled autoSize :value="pd.user_name" style="width: 340px"></a-textarea>
              <a-button type="primary" @click="userFlag = true">选择经办人</a-button>
            </a-input-group>
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            申请人:
          </div>

          <div
            v-if="permission(['contract', 'apply/:id?'], 'bind_company')"
            class="float-right pl-2"
            :style="{ width: '550px' }"
          >
            <a-input-group compact>
              <a-auto-complete
                v-model="bidder"
                allowClear='true'
                @blur="handleBlur" 
                :dataSource="companySearchs"
                @search="(v) => onCompanySearch(v)"
                @select="(_, option) => companySelect(option)"
                style="width: 354px"
              >
                <a-textarea placeholder="请输入企业名称" autoSize />
              </a-auto-complete>
              <a-button type="primary" @click="companyFlag = true">新增企业</a-button>
            </a-input-group>
          </div>

          <div v-else class="float-right pl-2" :style="{ width: '550px' }">
            {{ bidder }}
          </div>
        </div>
        <div
          v-if="company.taxNumber"
          class="w-full pb-4 overflow-hidden"
          :style="{ width: '750px' }"
        >
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            统一社会信用代码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ company.taxNumber }}
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            联系人:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-auto-complete
              v-model="pd.sendName"
              :dataSource="contact2options2"
              @select="(_, option) => telSelect(option)"
              style="width: 442px"
            >
            </a-auto-complete>
            <!-- <a-auto-complete v-model="pd.sendName" style="width: 442px" @select="telSelect">
              <template slot="dataSource">
                <a-select-option v-for="(item, index) in contact2s" :key="index" :value="item.name"
                  >{{ item.name }}
                </a-select-option>
              </template>
            </a-auto-complete> -->
          </div>
        </div>
        <div class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            联系人号码:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            <a-auto-complete
              v-model="pd.telephone"
              :dataSource="contact2options"
              @select="(_, option) => telSelect(option)"
              style="width: 442px"
            >
            </a-auto-complete>
          </div>
        </div>
        <div
          v-if="company.bankName"
          class="w-full pb-4 overflow-hidden"
          :style="{ width: '750px' }"
        >
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            开户行:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ company.bankName }}
          </div>
        </div>
        <div
          v-if="company.bankAccount"
          class="w-full pb-4 overflow-hidden"
          :style="{ width: '750px' }"
        >
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }">
            开户行账号:
          </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ company.bankAccount }}
          </div>
        </div>
        <div v-if="company.address" class="w-full pb-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left text-right text-gray-400" :style="{ width: '200px' }"> 地址: </div>
          <div class="float-right pl-2" :style="{ width: '550px' }">
            {{ company.address }}
          </div>
        </div>
        <div
          v-if="certificateFlag"
          class="w-full pb-4 overflow-hidden"
          :style="{ paddingLeft: '27%' }"
        >
          <div class="overflow-hidden">
            <CertificateUpload
              :disabled="disabled"
              :src="company.certificate_src"
              @upload="certUpload"
            ></CertificateUpload>
          </div>
          <div class="float-left pt-2 text-right text-gray-400" :style="{ width: '200px' }">
            开户许可证
          </div>
          <!-- <span class="pl-10 "  >开户许可证</span> -->
        </div>

        <div class="overflow-hidden text-sm" :style="{ width: '750px' }">
          <div class="float-left h-2" :style="{ width: '200px' }"></div>
          <div class="float-left">
            <a-checkbox v-model="agreement">您已阅读并同意</a-checkbox>
            <span class="text-red-500 cursor-pointer" @click="agreementFlag = true"
              >《电子保函申请书》</span
            >
          </div>
        </div>
        <div class="justify-center w-full py-4 overflow-hidden" :style="{ width: '750px' }">
          <div class="float-left h-2" :style="{ width: '200px' }"></div>
          <a-button class="float-left" type="primary" @click="doContract" :disabled="isok">
            提交申请
          </a-button>
          <a-button class="float-left ml-6" type="primary" @click="previewContract" :disabled="canPreview">
            保函预览
          </a-button>
        </div>
      </div>
    </a-spin>
    <a-modal
      :visible="agreementFlag"
      title="《电子保函申请书》"
      :width="595"
      :footer="null"
      :bodyStyle="{ padding: 0 }"
      @cancel="agreementFlag = false"
    >
      <div
        v-html="agreementText"
        style="padding: 30px 57px; height: calc(100vh - 300px); overflow-y: scroll"
      ></div>
    </a-modal>
    <ProjectSelect
      :visible="projectFlag"
      @cancel="() => (projectFlag = false)"
      @ok="projectSelect"
    ></ProjectSelect>
    <UserSelect
      :visible="userFlag"
      @cancel="() => (userFlag = false)"
      @ok="userSelect"
    ></UserSelect>
    <CompanyForm
      :visible="companyFlag"
      @cancel="() => (companyFlag = false)"
      @ok="companyAdd"
    ></CompanyForm>
    <a-modal
      title="保函格式预览"
      :visible="previewFlag"
      :footer="null"
      @cancel="previewFlag = false"
      forceRender
      width="842px"
      :bodyStyle="{ padding: 0 }"
    >
      <content-preview :content="content"></content-preview>
    </a-modal>
  </div>
</template>

<script>
  import CertificateUpload from '@/components/CertificateUpload/index';
  import { convertCurrency, transContentP2, transContentApply } from '@/utils/transContent';
  import permission from '@/utils/permission';
  import { projectbyid } from '@/api/project';
  import { previewlink } from '@/utils/tool';
  import ContentPreview from '@/components/ContentPreview/index';
  import { contractSaveByProject } from '@/api/contract';
  import { contacts2 } from '@/api/contact';
  import { companysByProject, companyCertificateModify } from '@/api/company';
  import dayjs from 'dayjs';
  import { debounce } from 'lodash';
  import ProjectSelect from './module/project-select.vue';
  import UserSelect from './module/user-select.vue';
  import CompanyForm from './module/company-form.vue';
  import { v4 as uuidv4 } from 'uuid';
  import { temp } from '@/api/temp';
  export default {
    components: {
      ProjectSelect,
      UserSelect,
      CompanyForm,
      CertificateUpload,
      ContentPreview
    },
    props: {
      reopen: Number,
      companyp: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        agreement: false,
        spinning: false,
        tempInfo: {},
        agreementFlag: false,
        projectFlag: false,
        userFlag: false,
        project: {},
        disabled: false,
        certificateFlag: false,
        content: '',
        previewFlag: false,
        pd: {
          company_id: 0,
          r_code: 0,
        },
        info: {},
        //
        company: {},
        bidder: '',
        companySearchs: [],
        onCompanySearch: debounce(this.companysearch, 500),
        companyFlag: false,
        loading: false,
        contact2s: [],
        //
      };
    },
    computed: {
      agreementText() {
        return this.tempInfo.agreement && this.project.poundage
          ? transContentP2(
              this.tempInfo.agreement,
              this.project,
              this.bidder,
              this.project.poundage,
            )
          : '';
      },
      isok() {
        return !this.pd.company_id || !this.project.id || !this.agreement;
      },
      contact2options() {
        let ops = [];
        for (let i = 0; i < this.contact2s.length; i++) {
          const e = this.contact2s[i];
          ops.push({ text: e.phone_number, value: e.id.toString(), data: e });
        }
        return ops;
      },
      contact2options2() {
        let ops = [];
        for (let i = 0; i < this.contact2s.length; i++) {
          const e = this.contact2s[i];
          ops.push({ text: e.name, value: e.id.toString(), data: e });
        }
        return ops;
      },
      canPreview() {
        return !this.project.id;
      },
    },
    watch: {
      async reopen(a) {
        this.project = {};
        this.pd = {};
        this.info = {};
        if (this.permission(['contract', 'apply/:id?'], 'bind_company')) {
          this.company = {};
          this.bidder = '';
        } else {
          this.company = this.companyp;
          this.bidder = this.companyp.owner;
          this.$set(this.pd, 'company_id', this.company.id);
        }
        if (this.$route.query) {
          if (this.$route.query.project_id) {
            let res = await projectbyid(this.$route.query.project_id);
            let now = dayjs().format('YYYY-MM-DD HH:mm:ss');
            if (res.bidder_timef > now) {
              this.project = res;
              this.info = {
                ...res,
                project: res.name,
              };
              this.tempInfo = await temp(res.temp_id);
            }
          }
        }
      },
      async 'company.taxNumber'(a) {
        this.contact2s =
          (await contacts2({ qp: JSON.stringify({ eq: { taxNumber: a } }) })).data || [];
      },
    },

    methods: {
      previewlink,
      telSelect({ key }) {
        let c2 = this.contact2s.find((e) => {
          return e.id == key;
        });
        this.$set(this.pd, 'telephone', c2.phone_number);
        this.$set(this.pd, 'sendName', c2.name);
      },
      beforeUpload(file) {
        const isLt = file.size / 1024 / 1024 < 50;
        if (!isLt) {
          this.$message.error('上传文件需小于50MB!');
          return false;
        }
        return isLt;
      },
      async api2(e) {
        let formData = new FormData();
        formData.append('file', e.file);
        formData.append('where', 'bidding_file');
        formData.append('style', '1');
        this.loading = true;
        let res = await this.$uploadfile('/api/v1/file_upload', formData);
        this.$set(this.pd, 'bidding_file', res.pathname);
        this.$set(this.pd, 'bidding_file_id', res.id);
        this.$set(this.pd, 'bidding_file_name', res.filename);
        this.loading = false;
        this.get();
        this.$message.success('上传成功');
      },
      convertCurrency,
      permission,
       handleBlur() {
    
    if (this.bidder) {
     this.onCompanySearch(this.bidder);
    if(this.companySearchs.length>0){
      let company=this.companySearchs[0].company;
       this.$set(this.pd, 'company_id', company.id);
        this.company = company;
        this.bidder = company.owner;
        this.info.company = company;
    }else{
      this.company = "";
       
        this.info.company = "";
    }
      
    }else{
      
        this.company = "";
        this.bidder = "";
        this.info.company = "";}
  },
      async companysearch(searchText) {
        if (searchText) {
          let res = await companysByProject(searchText);
          console.log(res);
          if (res) {
            this.companySearchs = res.map((e) => {
              return { text: e.owner, value: e.id.toString(), company: e };
            });
          } else {
            this.companySearchs = [];
          }
        }
      },
      async certUpload(res) {
        try {
          this.spinning = true;
          this.company.certificate_id = res.id;
          this.company.certificate_src = res.pathname;
          await companyCertificateModify(this.company);
        } catch (error) {
          this.$message.error(error);
        } finally {
          this.spinning = false;
        }
      },
      companySelect({ key }) {
        let company = this.companySearchs.find((e) => {
          return e.value == key;
        }).company;
        this.$set(this.pd, 'company_id', company.id);
        this.company = company;
        this.bidder = company.owner;
        this.info.company = company;
      },
      async projectSelect(record) {
        this.project = record;
        this.info = {
          ...this.info,
          ...record,
          project: record.name,
        };
        this.projectFlag = false;
        this.certificateFlag = record.temp.is_certificate;
        // this.pd.r_code = record.user_id;
        this.tempInfo = await temp(this.project.temp_id);
      },
      userSelect(record) {
        this.pd.user_id = Number(record.id);
        this.$set(this.pd, 'user_name', record.name);
        this.userFlag = false;
      },
      companyAdd(company) {
        this.pd.company_id = company.id;
        this.company = company;
        this.bidder = company.owner;
      },
      async doContract() {
        if (permission(['contract', 'apply/:id?'], 'bind_company')) {
          if (!this.pd.company_id) {
            this.$message.error('请先选择申请人');
            return;
          }
        }
        if (this.project.temp_category_id != 2 && !this.pd.money) {
          this.$message.error('请输入担保额度');
          return;
        }
        if (this.project.temp_category_id != 2 && !this.pd.bidding_file) {
          this.$message.error('请上传中标通知书');
          return;
        }
        if (this.certificateFlag && !this.company.certificate_src) {
          this.$message.error('请上传开户许可证');
          return;
        }
        this.pd.project_id = this.project.id;
        if (this.project.loc_id == 18) {
          if (!this.pd.sendName) {
            this.$message.error('请输入联系人');
            return;
          }
          if (!this.pd.telephone) {
            this.$message.error('联系人号码有误，请重新输入');
            return;
          }
        }
        try {
          this.spinning = true;
          let uuid = window.localStorage.getItem('DOUUID');
          if (!uuid) {
            uuid = uuidv4();
            window.localStorage.setItem('DOUUID', uuid);
          }
          this.pd.fingerprint = uuid;

          const ct = await contractSaveByProject(this.pd);
          this.$emit('next', ct);
        } catch (error) {
          this.$message.error(error);
        } finally {
          this.spinning = false;
        }
      },
      getContent() {
        let temp = this.tempInfo;
        let c = '';
        if (temp) {
          c = transContentApply(temp.content_2, this.info);
        }
        return c;
      },
      previewContract() {
        this.content = this.getContent();
        this.previewFlag = true;
      }
    },
  };
</script>
